import { FC } from "react";

import classes from "./OngoingBattle.module.css";
import { BattleModelDocument } from "../image/Image";

interface Props extends BattleModelDocument {
  currentUserIndex: number;
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const OngoingBattle: FC<Props> = ({
  _id,
  user1ID,
  artwork1ID,
  artwork1Src,
  category,
  tags,
  nextLevelBattleForUser1,
  nextLevelBattleForUser2,
  user2ID,
  artwork2ID,
  artwork2Src,
  level,
  votesCount,
  artwork1VotesCount,
  artwork2VotesCount,
  winnerArtworkID,
  status,
  winnerDecision,
  createdAt,
  currentUserIndex,
  topic,
  setPopupImage,
}) => {
  let prizePool = 0;
  switch (level) {
    case 1:
      prizePool = 0;
      break;
    case 2:
      prizePool = 10;
      break;
    case 3:
      prizePool = 25;
      break;
    case 4:
      prizePool = 50;
      break;
    case 5:
      prizePool = 90;
      break;
    case 6:
      prizePool = 150;
      break;
    case 7:
      prizePool = 250;
      break;
  }
  const userImage =
    currentUserIndex === 0
      ? {
          src: artwork1Src,
          votesCount: artwork1VotesCount,
          lose: artwork1VotesCount < artwork2VotesCount,
        }
      : {
          src: artwork2Src,
          votesCount: artwork2VotesCount,
          lose: artwork2VotesCount < artwork1VotesCount,
        };
  const enemyImage =
    currentUserIndex === 1
      ? {
          src: artwork1Src,
          votesCount: artwork1VotesCount,
          lose: artwork1VotesCount < artwork2VotesCount,
          _id: artwork1ID,
        }
      : {
          src: artwork2Src,
          votesCount: artwork2VotesCount,
          lose: artwork2VotesCount < artwork1VotesCount,
          _id: artwork2ID,
        };
  return (
    <div className={classes.votepair}>
      <div className={classes.title}>
        <span className={classes.left}>
          <span>{topic.title}</span>
          <div className={classes.value}>
            {prizePool > 0 && <span>{prizePool} 🌕 or </span>}
            <span className={classes.ticket}>
              <svg
                width="27px"
                height="27px"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="#fff"
                  d="M640 832H64V640a128 128 0 1 0 0-256V192h576v160h64V192h256v192a128 128 0 1 0 0 256v192H704V672h-64v160zm0-416v192h64V416h-64z"
                />
              </svg>
              <span className={classes.ticketLabel}>{level + 1}</span>
            </span>
          </div>
        </span>
        <span className={classes.level}>
          Level <span className={classes.points}>{level}</span>
        </span>
      </div>
      {/* <div className={classes.info}>
        <div className={classes.level}>
          <div className={classes.rate}>
            <h2>Battle Level</h2>
            <div className={classes.points}>{level}</div>
          </div>
        </div>
        <div className={classes.bet}>
          <div className={classes.label}>Prize Pool</div>
          <div className={classes.value}>{prizePool} 🌕</div>
        </div>
      </div> */}
      <div className={classes.images}>
        <div className={`${classes.img} ${classes.voted}`}>
          <img src={userImage.src} alt="" />
          <div
            className={`${classes.score} ${
              userImage.lose ? classes.lose : classes.win
            }`}
          >
            {userImage.votesCount}
          </div>
        </div>
        <div
          className={`${classes.img}`}
          onClick={() => {
            setPopupImage(enemyImage._id || "");
          }}
        >
          <span className={classes.popupIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              clipRule="evenodd"
              viewBox="0 0 509 511.54"
            >
              <path
                fillRule="nonzero"
                fill="#fff"
                d="M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z"
              />
            </svg>
          </span>
          <img src={enemyImage.src} alt="" />
          <div
            className={`${classes.score} ${
              enemyImage.lose ? classes.lose : classes.win
            }`}
          >
            {enemyImage.votesCount}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OngoingBattle;
